import { render, staticRenderFns } from "./DetailComment.vue?vue&type=template&id=6968ecb4&scoped=true&"
import script from "./DetailComment.vue?vue&type=script&lang=js&"
export * from "./DetailComment.vue?vue&type=script&lang=js&"
import style0 from "./DetailComment.vue?vue&type=style&index=0&id=6968ecb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968ecb4",
  null
  
)

export default component.exports